<template>
  <div
    class="discount-item"
  >
    <span class="bold bl-color font-size-16 mr-2">{{ discount.zmena }}%</span>
    <div>
      {{ discount.label }} - <span v-if="discount.poznamka"> {{ discount.poznamka }}</span>
    </div>
    <div v-if="discount.inactive_reasons && discount.inactive_reasons.length" class="discount-item__automatic">
      Vybrané – zatiaľ nezapočítané
      <span class="ml-2 text-cta noselect" @click="removeSadzbaChange(discount.id, discount.zmena)">Zrušiť zľavu</span>
    </div>
    <div v-else-if="discount.auto_waived" class="discount-item__automatic">
      Prirážka odpustená – podmienky banky / kampaň
    </div>
    <div v-else-if="discount.auto_applied" class="discount-item__automatic">
      Automaticky uplatnené
    </div>
    <div v-else-if="discount.ltv_not_applicable_reason" class="discount-item__automatic">
      {{ discount.ltv_not_applicable_reason }}
    </div>
    <div v-else-if="discount.product_unavailable_reason" class="discount-item__automatic">
      {{ discount.product_unavailable_reason }}
    </div>
    <div v-else-if="discount.account_included" class="discount-item__automatic">
      Bez prirážky – účet sa používa
    </div>
    <div v-else-if="!loading">
      <span
        v-if="!picked"
        class="ml-2 text-cta noselect"
        @click="applySadzbaChange(discount.id, discount.zmena)"
      >
        Uplatniť
      </span>
      <span
        v-else
        class="ml-2 text-cta noselect"
        @click="removeSadzbaChange(discount.id, discount.zmena)"
      >
        Zrušiť
      </span>
    </div>
    <div class="ml-3" v-else>
      <v-progress-circular
        class="loading-spinner extrasmall"
        indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiscountItem",
  props: {
    discount: Object,
    mortgageRateChanges: Array,
    mortgageId: Number,
  },
  computed: {
    picked() {
      if (typeof this.discount.applied === "boolean") return this.discount.applied;
      return (this.mortgageRateChanges || []).includes(this.discount.id)
    }
  },
  methods: {
    productSetting(enabled, selectedIds) {
      const field = this.discount.typ;
      if (!["poistenie_uveru_v_banke", "poistenie_nehnutelnosti_v_banke"].includes(field)) return {};
      if (!enabled) {
        const offers = this.$store.getters["mortgageDetailState/getOffers"] || [];
        const stillSelected = offers.some(offer => (offer.extra?.mozne_zmeny_sadzieb || [])
          .some(change => change.typ === field && selectedIds.includes(change.id)));
        return {[field]: stillSelected};
      }
      return {[field]: true};
    },
    async updateRateChange(id, enabled, change) {
      if (this.loading) return;
      this.loading = true;
      const selected = new Set(this.mortgageRateChanges || []);
      if (enabled) selected.add(id); else selected.delete(id);
      const ids = [...selected];
      const products = this.productSetting(enabled, ids);
      try {
        await this.$store.dispatch("mortgageDetailState/patchMortgage", {
          id: this.mortgageId,
          object: {uplatnene_zmeny_sadzieb: ids, ...products},
        });
        const storedIds = this.$store.getters["mortgageDetailState/getAppliedMortgageRateChanges"] || [];
        const mortgage = this.$store.getters["mortgageDetailState/getMortgage"] || {};
        if (storedIds.includes(id) !== enabled || Object.entries(products).some(([key, value]) => Boolean(mortgage[key]) !== value)) {
          throw new Error("Zmena nebola uložená.");
        }
        if (Object.keys(products).length) {
          await this.$store.dispatch("mortgageDetailState/fetchOffers", this.mortgageId);
        } else {
          this.$emit("discount-change", change);
        }
      } catch (error) {
        this.$store.commit("appState/setSuccessMessage", {text: "Zmenu produktu alebo zľavy sa nepodarilo uložiť. Skúste znova.", type: "error"});
      } finally {
        this.loading = false;
      }
    },
    applySadzbaChange(id, change) {
      return this.updateRateChange(id, true, change);
    },
    removeSadzbaChange(id, change) {
      return this.updateRateChange(id, false, change);
    },
  },
  data: () => ({
    loading: false,
  }),
}
</script>

<style lang="scss" scoped>
.discount-item {
  margin: 0;
  padding: 8px 11px;
  gap: 5px;
  border: 1px solid var(--app-border);
  border-radius: 9px;
  background: var(--app-surface-muted);
  color: var(--app-text);
  font-size: 10px;
}

.discount-item .font-size-16 {
  color: var(--app-primary) !important;
  font-size: 13px !important;
  font-weight: 800;
}

.discount-item .text-cta {
  color: var(--app-primary) !important;
  padding: 5px 8px !important;
  border-radius: 7px;
  background: var(--app-primary-soft);
  font-size: 10px;
  font-weight: 800;
}

.discount-item__automatic {
  margin-left: 8px;
  padding: 5px 8px;
  border-radius: 7px;
  background: var(--app-warning-soft, #fff4d6);
  color: var(--app-warning, #8a5a00);
  font-size: 10px;
  font-weight: 800;
}
</style>
